export const findTag = (tags: Array<string>, tagName: string): undefined | string => {
	for (const tag of tags) {
		const parts = tag.split(":");

		if (parts.length === 2 && parts[0] === tagName) {
			return parts[1];
		}
	}

	return undefined;
};
